import * as angular from "angular";

const timekeepingTableColumnsMap = {
  employeeId: {enabled: true, order: 1, permission: undefined},
  employeeZip: {enabled: false, order: 2, permission: undefined},
  jobTitle: {enabled: true, order: 3, permission: undefined},
  branch: {enabled: true, order: 4, permission: undefined},
  distance: {enabled: true, order: 5, permission: undefined},
  mph: {enabled: true, order: 6, permission: undefined},
  serviceTime: {enabled: true, order: 7, permission: undefined},
  driveTime: {enabled: true, order: 8, permission: undefined},
  adminTime: {enabled: true, order: 9, permission: undefined},
  pto: {enabled: true, order: 10, permission: undefined},
  paidTime: {enabled: true, order: 11, permission: undefined},
  plannedTime: {enabled: true, order: 12, permission: undefined},
  stops: {enabled: true, order: 13, permission: undefined},
  break: {enabled: true, order: 14, permission: undefined},
  off: {enabled: true, order: 15, permission: undefined},
  status: {enabled: true, order: 16, permission: undefined},
};

angular
  .module('bringoz.admin.timekeeping')
  .constant('timekeepingConstants', {
    timekeepingTableColumnsMap: timekeepingTableColumnsMap,
  });
